/**
 * 用户接口
 * 科大平台用户接口API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The RskVerifyForm model module.
   * @module token/model/RskVerifyForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>RskVerifyForm</code>.
   * @alias module:token/model/RskVerifyForm
   * @class
   * @param captchaVerifyParam {String} 由验证码脚本回调的验证参数，直接将全部参数信息由客户端传给服务端即可。**警告** 禁止对验证参数做任何修改，否则业务会报错。
   * @param sceneId {String} 由服务端写入本次验证对应的场景ID，建议传入，尤其在多场景下，防止前端被篡改为其他场景。
   */
  var exports = function(captchaVerifyParam, sceneId) {
    var _this = this;

    _this['captchaVerifyParam'] = captchaVerifyParam;
    _this['sceneId'] = sceneId;
  };

  /**
   * Constructs a <code>RskVerifyForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:token/model/RskVerifyForm} obj Optional instance to populate.
   * @return {module:token/model/RskVerifyForm} The populated <code>RskVerifyForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'captchaVerifyParam')) {
        obj['captchaVerifyParam'] = ApiClient.convertToType(data['captchaVerifyParam'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'sceneId')) {
        obj['sceneId'] = ApiClient.convertToType(data['sceneId'], 'String');
      }
    }
    return obj;
  }

  /**
   * 由验证码脚本回调的验证参数，直接将全部参数信息由客户端传给服务端即可。**警告** 禁止对验证参数做任何修改，否则业务会报错。
   * @member {String} captchaVerifyParam
   */
  exports.prototype['captchaVerifyParam'] = undefined;
  /**
   * 由服务端写入本次验证对应的场景ID，建议传入，尤其在多场景下，防止前端被篡改为其他场景。
   * @member {String} sceneId
   */
  exports.prototype['sceneId'] = undefined;



  export default exports;
;


